<template>
    <div class="ARadioButtonGroup">
        <div class="ARadioButtonGroup__label">
            {{ title }}
        </div>
        <ARadioBtn v-for="option in options"
                   :option="{...option, ...{name}}"
                   :key="option.value"
                   @update:modelValue="inputEventHandler"
                   v-model="checked"
        />
    </div>
</template>

<script>
import {ref} from "vue";
import ARadioBtn from "./ARadioBtn";

export default {
    name: "ARadioButtonGroup",
    components: {ARadioBtn},
    props: {
        modelValue: String,
        title: String,
        name: {
            type: String,
            required: true
        },
        options: {
            required: true,
            type: Object,
            validator(val) {
                return Object.keys(val).includes('value') && Object.keys(val).includes('label')
            }
        }
    },
    setup(props, ctx) {
        const checked = ref(props.modelValue || null);
        const inputEventHandler = (value) => {
            ctx.emit('update:modelValue', value);
        }

        return {
            inputEventHandler,
            checked
        }
    }
}
</script>

<style scoped lang="scss">
.ARadioButtonGroup {
    margin-bottom: rem(50);

    &__label {
        display: block;
        font-weight: 600;
        font-size: rem(22);
        line-height: rem(28);
        margin-bottom: rem(30);
    }
}
</style>